import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Services } from "../components/site/Services";
import { About } from "../components/site/About";
import { Testimonials } from "../components/site/Testimonials";
import { Faq } from "../components/site/Faq";
import { InstagramSection } from "../components/site/InstagramSection";
import { MapSection } from "../components/site/MapSection";
import { Visit } from "../components/site/Visit";
import { BookingSection } from "../components/site/BookingSection";
import { Footer } from "../components/site/Footer";
import { WhatsAppFab } from "../components/site/WhatsAppFab";
import { CustomCursor } from "../components/site/CustomCursor";
import { Toaster } from "../components/ui/sonner";

export default function Landing() {
  return (
    <main className="bg-bone min-h-screen text-ink">
      <CustomCursor />
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <About />
      <Testimonials />
      <InstagramSection />
      <Faq />
      <MapSection />
      <Visit />
      <BookingSection />
      <Footer />
      <WhatsAppFab />
      <Toaster richColors position="top-center" />
    </main>
  );
}
